import React from 'react';
import PropTypes from 'prop-types';
// graphQL
import gql from 'graphql-tag';
import { userKinds } from 'config';
// our components
import { Query } from 'components/common/Query';
import WithPermission from 'components/User/WithPermission';
import Filter from './Filter';

/**
 * Query to fetch agencies from api
 */
export const AGENCIES_QUERY = gql`
  query AgenciesList($userType: [FilterUserType]!) {
    adminUsers(userType: $userType) {
      edges {
        node {
          id
          fullname
        }
      }
    }
  }
`;

/**
 * @description
 * Stateless component to handle user filters
 *
 * @param {Object} props - Component props.
 */
function UserAgencyFilterContainer(props) {
  const { showFilters, filter, appliedFilter } = props;
  return (
    <WithPermission
      alt={
        <Filter
          appliedFilter={appliedFilter}
          agencies={[]}
          filter={filter}
          showFilters={showFilters}
          t={() => ''}
        />
      }
      allowPermissions={['list_agency']}
    >
      <Query
        query={AGENCIES_QUERY}
        variables={{ userType: userKinds.AGENCY }}
        notifyOnNetworkStatusChange
      >
        {({ data, loading }) =>
          !loading && (
            <Filter
              appliedFilter={appliedFilter}
              agencies={data.adminUsers.edges}
              filter={filter}
              showFilters={showFilters}
              t={() => ''}
            />
          )
        }
      </Query>
    </WithPermission>
  );
}

/**
 * UserFilterContainer PropTypes
 * @param appliedFilter - prop pass to Filter
 * @param allowRanks - prop pass to Filter
 * @callback filter - prop pass to Filter
 * @callback showFilters - prop pass to Filter
 */

UserAgencyFilterContainer.propTypes = {
  appliedFilter: PropTypes.shape({}).isRequired,
  filter: PropTypes.func.isRequired,
  showFilters: PropTypes.func.isRequired,
};

export default UserAgencyFilterContainer;
